<template>
  <span class="svg-ico-arrow-up">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0805 3.45684C12.3701 3.18105 12.8252 3.18105 13.1148 3.45684L19.1148 9.16978C19.4148 9.45541 19.4265 9.93014 19.1408 10.2301C18.8552 10.5301 18.3805 10.5417 18.0805 10.2561L12.5977 5.0356L7.11484 10.2561C6.81485 10.5417 6.34012 10.5301 6.05449 10.2301C5.76886 9.93014 5.7805 9.45541 6.08048 9.16978L12.0805 3.45684Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5977 3.40993C13.0119 3.40993 13.3477 3.74571 13.3477 4.15993V19.9999C13.3477 20.4141 13.0119 20.7499 12.5977 20.7499C12.1834 20.7499 11.8477 20.4141 11.8477 19.9999V4.15993C11.8477 3.74571 12.1834 3.40993 12.5977 3.40993Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
